<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic js-tilt" data-tilt>
          <img
            class="img-fluid"
            :src="require('@/assets/images/login/login.png')"
            alt=""
          />
        </div>
        <form
          v-if="$store.state.user.uuid"
          @submit.prevent="submitDataLogin"
          class="login100-form validate-form"
        >
          <span class="login100-form-title font-weight-bold"> LOGIN AKUN </span>
          <div
            class="wrap-input100 validate-input d-flex align-items-center"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <img
              class="img-fluid img-profile rounded-circle"
              :src="$store.state.user.user_avatar_image"
              alt=""
            />
            <span class="ml-2">{{ $store.state.user.name }} </span>
          </div>
          <div
            class="wrap-input100 validate-input"
            data-validate="Password is required"
          >
            <input
              class="input100"
              type="password"
              name="pass"
              v-model="formLogin.password"
              placeholder="Password"
            />
            <span class="focus-input100"></span>
            <span class="symbol-input100">
              <i class="fa fa-graduation-cap" aria-hidden="true"></i>
            </span>
          </div>

          <div class="container-login100-form-btn">
            <button type="submit" class="login100-form-btn font-weight-bold">
              <b-spinner
                small
                class="mr-2"
                type="grow"
                v-show="isLoading"
              ></b-spinner>
              Login
            </button>
          </div>
          <div class="text-center p-t-12">
            <router-link :to="`/`">Kembali ke Halaman Utama</router-link>
          </div>
        </form>
        <form
          v-else
          @submit.prevent="submitData"
          class="login100-form validate-form"
        >
          <span class="login100-form-title font-weight-bold"> LOGIN AKUN </span>

          <div
            class="wrap-input100 validate-input"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <input
              class="input100"
              type="number"
              name="email"
              v-model="formLogin.nis_nik"
              placeholder="Ketikkan NISN/NIS/NIK"
            />
            <span class="focus-input100"></span>
            <span class="symbol-input100">
              <i class="fa fa-address-card" aria-hidden="true"></i>
            </span>
          </div>

          <div
            class="wrap-input100 validate-input"
            data-validate="Password is required"
          >
            <input
              class="input100"
              type="text"
              name="pass"
              disabled
              v-model="formLogin.school_name"
              placeholder="Sekolah"
            />
            <span class="focus-input100"></span>
            <span class="symbol-input100">
              <i class="fa fa-graduation-cap" aria-hidden="true"></i>
            </span>
          </div>

          <div class="container-login100-form-btn">
            <button type="submit" class="login100-form-btn font-weight-bold">
              <b-spinner
                small
                class="mr-2"
                type="grow"
                v-show="isLoading"
              ></b-spinner>
              MASUK
            </button>
          </div>
          <div class="text-center p-t-12">
            <router-link :to="`/`">Kembali ke Halaman Utama</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import broker from "../../utils/broker";
export default {
  name: "Login",
  data() {
    return {
      formLogin: {
        nis_nik: "",
        school_id: this.$store.state.school.id,
        school_name: this.$store.state.school.name,
        password: "",
        uuid: this.$store.state.user.uuid,
      },
      isLoading: false,
    };
  },
  mounted() {
    console.log(`----`, this.$store.state.school);
  },
  methods: {
    async submitData() {
      let formData = {
        nisn_nik: this.formLogin.nis_nik,
        school_id: this.formLogin.school_id,
      };
      this.isLoading = true;
      await broker.fetch
        .post(`/mobile/app/authentication/check-account`, formData)
        .then((response) => {
          this.$store.dispatch("updateUser", response.data.data);
          let message = "Login Berhasil !";
          this.$Toast.fire({
            title: message,
            icon: "success",
          });
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoading = false;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },

    async submitDataLogin() {
      this.isLoading = true;
      let formData = {
        uuid: this.$store.state.user.uuid,
        password: this.formLogin.password,
      };
      await broker.fetch
        .post(`/mobile/app/authentication/login-account`, formData)
        .then((response) => {
          this.$store.dispatch("updateUserToken", response.data.meta.token);
          let message = "Login Berhasil !";
          this.$Toast.fire({
            title: message,
            icon: "success",
          });
          window.location.href = "/";

          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            let message = error.response.data.error;
            this.isLoading = false;
            this.$Toast.fire({
              title: message,
              icon: "error",
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_login_3.scss";
</style>
